export default options => {
  function clearSpace(ctx) {
    ctx.save()
    ctx.globalCompositeOperation = 'source-over'
    ctx.fillStyle = 'black'
    // ctx.fillRect(0, 0, canvas.width, canvas.height)
    ctx.restore()
  }
  //
  const PI = Math.PI;
  const round = Math.round;
  const random = Math.random;

  function particle() {
    this.speed = {
      x: -1 + random() * 2,
      y: -5 + random() * 5
    }

    this.radius = .5 + random();
    this.death = 10 + random() * 10;
    this.life = this.death;
    this.rgb = `255, ${round(random() * 255)}, 0`;
  }

  const particles = [];
  const PARTICLE_COUNT = 150;

  for (let i = 0; i < PARTICLE_COUNT; i++) {
    particles.push(new particle())
  }

  return options => {
    let {
      x,
      y,
      ctx
    } = options;

    clearSpace(ctx)
    ctx.globalCompositeOperation = 'lighter'
    particles.forEach((p, i) => {
      if (!p.x || !p.y) {
        p.x = x;
        p.y = y;
      }
      const gradient = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.radius)
      p.opacity = random() * (p.death / p.life)

      gradient.addColorStop(0, `rgba(${p.rgb},${p.opacity})`)
      gradient.addColorStop(.5, `rgba(${p.rgb},${p.opacity})`)
      gradient.addColorStop(1, `rgba(${p.rgb},0)`)
      ctx.fillStyle = gradient
      ctx.beginPath()
      ctx.arc(p.x, p.y, p.radius, 0, PI * 2)
      ctx.fill()

      p.x += p.speed.x
      p.y += p.speed.y
      p.death--
      p.radius++
      if (p.radius <= 0 || p.opacity <= 0) {
        let part = particles[i] = new particle();
        part.x = x;
        part.y = y;
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/animate/flame.js